import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  height: 20px;\n  padding: 0 16px;\n  margin-bottom: 16px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  margin-left: 4px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  padding-top: 16px; /* workaround for flex not margin collapse */\n  width: 100%;\n  height: auto;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../icon/Icon';
var StyledCardInfo = styled.ul(_templateObject());
var Text = styled.span(_templateObject2(), themeGet('cardInfo.fontSize'), themeGet('cardInfo.color'));
var Info = styled.li(_templateObject3(), ellipsis());
export var CardInfo = function CardInfo(_ref) {
  var data = _ref.data;
  return (
    /*#__PURE__*/
    React.createElement(StyledCardInfo, null, data.map(function (info) {
      return (
        /*#__PURE__*/
        React.createElement(Info, {
          key: info.icon_name
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: info.icon_name
        }),
        /*#__PURE__*/
        React.createElement(Text, null, info.text))
      );
    }))
  );
};